import { styled } from '@pata-app/themes';

export const HeroSectionContainer = styled.section`
  position: relative;

  > img {
    display: none;
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    height: 100%;

    margin: auto;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.s}`} {
    display: flex;

    height: 550px;

    overflow: hidden;
  }
`;

export const HeroOverviewContainer = styled.div`
  bottom: 0;
  display: flex;
  flex-direction: column;

  > img {
    margin-bottom: ${({ theme }) => theme.core.sizing[4]}px;

    width: 100%;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.m}`} {
    width: 60%;

    /* margin: ${({ theme }) => theme.core.sizing[2]}px; */
    margin-bottom: 0;
    /* margin: 0; */
  }
`;

export const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.core.sizing[3]}px;

  border-radius: ${({ theme }) => theme.core.border.element.radius}px
    ${({ theme }) => theme.core.border.element.radius}px 0 0;

  color: ${({ theme }) => theme.core.colors.greyscale.black};

  padding: ${({ theme }) => theme.core.sizing[4]}px;

  h1 {
    margin: 0;

    font-family: ${({ theme }) => theme.core.fontFamily.jost};
    font-size: 40px;

    span {
      color: ${({ theme }) => theme.core.colors.primary.green.medium};
    }
  }

  strong {
    margin: 0;

    font-size: ${({ theme }) => theme.core.fontSizes.xxl}px;
    font-weight: ${({ theme }) => theme.core.fontWeight.semiBold};

    text-align: center;

    max-width: 600px;
  }

  > p {
    margin: 0;
    max-width: 600px;
    font-size: ${({ theme }) => theme.core.fontSizes.l}px;

    padding-bottom: ${({ theme }) => theme.core.sizing[2]}px;

    /* color: ${({ theme }) => theme.core.colors.greyscale.white}; */
  }

  button {
    cursor: pointer;
    min-width: 150px;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.l}`} {
    max-width: 850px;

    margin-left: -40px;
    padding: ${({ theme }) => theme.core.sizing[5]}px;
    padding-bottom: ${({ theme }) => theme.core.sizing[5]}px;

    padding-top: 120px;

    h1 {
      font-size: 45px;
    }
  }

  @media ${({ theme }) => `${theme.core.breakpoints.xl}`} {
    padding-bottom: 70px;
  }
`;

export const HighlightContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.core.sizing[2]}px;

  background: ${({ theme }) => theme.core.colors.greyscale.light};

  h3 {
    margin: 0;

    font-family: ${({ theme }) => theme.core.fontFamily.jost};
    font-size: ${({ theme }) => theme.core.fontSizes.l}px;

    color: ${({ theme }) => theme.core.colors.primary.green.medium};
  }

  p {
    margin: 0;
  }

  > span {
    align-self: flex-end;

    strong {
      font-size: ${({ theme }) => theme.core.fontSizes.xl}px;
    }
  }
  @media ${({ theme }) => `${theme.core.breakpoints.l}`} {
    padding: ${({ theme }) => theme.core.sizing[2]}px;
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  align-self: center;
  gap: ${({ theme }) => theme.core.sizing[2]}px;
`;
